export default __webpack_public_path__ + "static/media/user-role.f8f67215.webp";